export default function onChangePhoneNumber(e, onChange) {
  let value = e.target.value;

  if (!value) {
    onChange("");
    return;
  }

  // Keep numbers only
  value = value.replace(/[^0-9]/g, "");

  // Remove any leading zeros
  value = value.replace(/^0+/, "");

  onChange(value);
}
